export default __webpack_public_path__ + "static/media/Animals-10.ca5c1c74.png";